import type { AVPlaybackSource } from 'expo-av'

export type UiSoundId =
  | 'vote'
  | 'accept-contribution'
  | 'reject-contribution'
  | 'censure-contribution'
  | 'race-start'

/**
 * Bundled assets only. Example:
 * 'action-primary-tap': require('../assets/sounds/primary-tap.mp3'),
 */
export const UI_SOUND_SOURCES: Partial<Record<UiSoundId, AVPlaybackSource>> = {
  vote: require('../assets/audio/vote.mp3'),
  'accept-contribution': require('../assets/audio/accept-contribution.mp3'),
  'reject-contribution': require('../assets/audio/reject-contribution.mp3'),
  'censure-contribution': require('../assets/audio/censure-contribution.mp3'),
  'race-start': require('../assets/audio/race-start.mp3'),
}

export const getRegisteredUiSoundIds = (): UiSoundId[] =>
  (Object.keys(UI_SOUND_SOURCES) as UiSoundId[]).filter(
    (id) => UI_SOUND_SOURCES[id] != null
  )
